import React from 'react';

const ClipboardIcon = ({ color = '#424242', width = 24, height = 25, ...rest }, ref) => {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 4.50195C18.175 4.51406 19.3529 4.61051 20.1213 5.37889C21 6.25757 21 7.67179 21 10.5002V16.5002C21 19.3286 21 20.7429 20.1213 21.6215C19.2426 22.5002 17.8284 22.5002 15 22.5002H9C6.17157 22.5002 4.75736 22.5002 3.87868 21.6215C3 20.7429 3 19.3286 3 16.5002V10.5002C3 7.67179 3 6.25757 3.87868 5.37889C4.64706 4.61051 5.82497 4.51406 8 4.50195"
        stroke={color}
        stroke-width="1.5"
      />
      <path d="M8 14.5H16" stroke={color} stroke-width="1.5" stroke-linecap="round" />
      <path d="M7 11H17" stroke={color} stroke-width="1.5" stroke-linecap="round" />
      <path d="M9 18H15" stroke={color} stroke-width="1.5" stroke-linecap="round" />
      <path
        d="M8 4C8 3.17157 8.67157 2.5 9.5 2.5H14.5C15.3284 2.5 16 3.17157 16 4V5C16 5.82843 15.3284 6.5 14.5 6.5H9.5C8.67157 6.5 8 5.82843 8 5V4Z"
        stroke={color}
        stroke-width="1.5"
      />
    </svg>
  );
};

export default ClipboardIcon;
